















import {
    computed,
    defineComponent,
    ref,
} from '@vue/composition-api';

import { useTooltipManager } from './TooltipManager';
import { TooltipDefinition } from './types';

/**
 * NOTE: This component uses a faux-portal to render a tooltip
 * outside of the scope of the element as raw html.
 * However, it is quite fragile and non-reactive, so use it
 * sparringly and carefully. It was originally a hack for displaying
 * the TV channels content, which is basically static.
 */
export default defineComponent({
    name: 'SdsTooltipPortal',
    setup() {
        const tooltipRef = ref<HTMLElement>();
        const tooltip = useTooltipManager();

        const definition = computed<TooltipDefinition>(() => ({
            text: tooltipRef.value?.innerHTML ?? '',
            variant: 'primary',
            orientation: 'auto',
            isHtml: true,
            isRaw: true,
        }));

        function onMouseEnter(event: MouseEvent) {
            const element = event.target as HTMLElement;
            if (!element) {
                return;
            }

            tooltip.setActiveTooltip(definition.value, element);
        }

        function onMouseLeave() {
            tooltip.clearActiveTooltip();
        }

        function onClick(event: MouseEvent) {
            const element = event.target as HTMLElement;
            if (!element) {
                return;
            }

            tooltip.toggleActiveTooltip(definition.value, element);
        }

        const activatorOn = {
            mouseenter: onMouseEnter,
            mouseleave: onMouseLeave,
            click: onClick,
        };

        return {
            activatorOn,
            tooltipRef,
        };
    },
});
